import { TimelineMax } from 'gsap';

export default (obj) => {
    const timeline = new TimelineMax();

    timeline.fromTo(obj, 1, {
        autoAlpha: 0,
    }, {
        autoAlpha: 1,
    });

    return timeline;
};



// WEBPACK FOOTER //
// ./animations/fadeIn.js